import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { STATUS_TYPES, StatusType } from "@shared/types/status.types";
import { IconModule } from '@ogs-gmbh/ngx-m3-components';
import { MatButtonModule } from "@angular/material/button";


const HOST_CLASS_BASE_NAME: string = "notify-chip";

@Component({
  selector: "app-shared-notify-chip",
  templateUrl: "./notify-chip.component.html",
  styleUrl: "notify-chip.component.scss",
  host: {
    '[class]': 'hostClass()'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CommonModule, IconModule, MatButtonModule ]
})
export class NotifyChipComponent {
  public readonly status: InputSignal<StatusType> = input<StatusType>(STATUS_TYPES.success);

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  public readonly hostClass: Signal<string> = computed(() => `${ HOST_CLASS_BASE_NAME }--${ this.status() }`);

  public readonly isCloseable: InputSignal<boolean> = input<boolean>(false);

  public readonly closed: OutputEmitterRef<void> = output();

  public closeToast (): void {
    this.closed.emit();
  }
}
